export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()

  // url 쿼리로 웹뷰 판단하는 건 가장 초기 버전. 추후 삭제 예정
  const source = route.query.source as string
  const headers = useRequestHeaders()

  // header에 웹뷰 판단 키가 있으면 웹뷰로 판단
  // ssr 에서 판단하기 위한 조건
  // csr 에서는 app.vue에서 판단
  const xFromApp = headers['x-from-app']

  return {
    provide: {
      isWebview: source === 'webview' || xFromApp === 'true',
    },
  }
})
